const testimonials = [
  {
    quote: 'The CSSBuy spreadsheet hub saved me hours of searching. Every link works, the categories are spot on, and I have found some absolute gems through their daily updates. Honestly the best resource out there for spreadsheet shopping.',
    name: 'Marcus Rivera',
    email: 'marcus.r@email.com',
    rating: 4.9,
  },
  {
    quote: 'I was skeptical at first but this hub is legit. The verified links actually go where they say they will, and the QC guides are surprisingly detailed. My go-to resource whenever I am building a new haul.',
    name: 'Sophie Chen',
    email: 'sophie.c@email.com',
    rating: 5.0,
  },
  {
    quote: 'Finally a spreadsheet resource that does not feel spammy. Clean UI, organized categories, and the daily updates mean I am always finding something new. The multi-platform coverage is a huge plus for comparing agents.',
    name: 'James Okafor',
    email: 'james.o@email.com',
    rating: 4.8,
  },
];

export default function Testimonials() {
  return (
    <section className="py-20 md:py-28 px-4 md:px-8 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 text-center mb-14 italic">
          (What They Say)
        </h2>

        <div className="relative">
          <div className="bg-background-50 rounded-2xl p-8 md:p-12">
            <div className="flex items-center gap-2 mb-8">
              <span className="inline-flex items-center gap-1.5 bg-foreground-950 text-white text-xs font-label font-semibold px-3 py-1.5 rounded-full">
                <i className="ri-star-fill text-accent-400 text-sm"></i>
                4.9 / 5.0
              </span>
            </div>

            <blockquote className="font-heading text-xl md:text-2xl text-foreground-800 leading-relaxed mb-8">
              &ldquo;{testimonials[0].quote}&rdquo;
            </blockquote>

            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-full overflow-hidden bg-background-200 flex items-center justify-center">
                <span className="font-label font-bold text-foreground-500 text-lg">
                  {testimonials[0].name.charAt(0)}
                </span>
              </div>
              <div>
                <p className="font-label font-semibold text-foreground-950 text-sm">{testimonials[0].name}</p>
                <p className="font-body text-foreground-400 text-xs">{testimonials[0].email}</p>
              </div>
            </div>
          </div>

          <div className="flex justify-end gap-2 mt-6">
            <button className="w-10 h-10 flex items-center justify-center rounded-lg border border-foreground-200 text-foreground-500 hover:bg-foreground-100 transition-colors duration-200 cursor-pointer">
              <i className="ri-arrow-left-line"></i>
            </button>
            <button className="w-10 h-10 flex items-center justify-center rounded-lg bg-foreground-950 text-white hover:bg-foreground-800 transition-colors duration-200 cursor-pointer">
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}